import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedServiceService } from './shared-service.service';

@Injectable({
  providedIn: 'root',
})
export class QuestService {
  private apiBaseUrl: string;

  constructor(private http: HttpClient, private sharedService: SharedServiceService) {
    this.apiBaseUrl = this.sharedService.baseUrl();
  }

  getQuests(): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'quests';
    return this.http.get(url, { headers });
  }

  saveQuest(payload: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'quests';
    return this.http.post(url, payload, { headers });
  }

  updateQuest(id: string, payload: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'quests/' + id;
    return this.http.put(url, payload, { headers });
  }

  // Mindfulness Session methods
  getMindfulnessSessions(): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'mindfulness';
    return this.http.get(url, { headers });
  }

  saveMindfulnessSession(payload: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'mindfulness';
    return this.http.post(url, payload, { headers });
  }

  updateMindfulnessSession(id: string, payload: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'mindfulness/' + id;
    return this.http.put(url, payload, { headers });
  }

  // Get Member Quest Info for assigning quests
  getMemberQuestInfo(): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'members/GetMemberQuestInfo';
    return this.http.get(url, { headers });
  }

  // Assign quests to members
  assignQuestsToMembers(payload: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'quests/AssignQuestsToMembers';
    return this.http.post(url, payload, { headers });
  }
}


